const TextboxAppend = ({
  id,
  name,
  register,
  errors,
  title,
  optional,
  append,
  ...rest
}) => {
  return (
    <>
      {title && (
        <label className="form-label" htmlFor={id}>
          {title}
          {optional && (
            <span className="text-xs ml-2 text-gray-300">Optional</span>
          )}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          name={name}
          className={`form-control ${errors && errors[name] && "form-invalid"}`}
          {...rest}
          {...register}
        />
        <div className="absolute inset-y-0 right-0 flex items-center px-2 ml-2 mr-1 my-2 bg-white">
          {append}
        </div>
      </div>
      {errors && errors[name] && (
        <div className="pt-2">
          <span className="text-sm text-red-400">{errors[name].message}</span>
        </div>
      )}
    </>
  );
};

export default TextboxAppend;
